import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { AmendmentCreateEditProvider } from './context/amendment-create-edit-context';
import { AmendmentCreateEditComponent } from './amendment-create-edit-component';

export function AmendmentCreateEditFactory() {
    return (
        <BaseLayoutFactory>
            <AmendmentCreateEditProvider>
                <AmendmentCreateEditComponent />
            </AmendmentCreateEditProvider>
        </BaseLayoutFactory>
    );
}
